<template>
  <label class="checkbox">
    <slot name="before"></slot>
    <input type="checkbox" v-bind="$attrs" />
    <slot />
  </label>
</template>
